var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "border-box",
        staticStyle: {
          "min-width": "400px",
          width: "40vw",
          margin: "auto",
          "margin-top": "100px",
        },
      },
      [
        _c("h3", { staticClass: "fg-color-blue" }, [
          _vm._v("Sign-in with SSO"),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.statusInitial || _vm.statusInvoking,
                expression: "statusInitial || statusInvoking",
              },
            ],
          },
          [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Email:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "email", placeholder: "Email address" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("ValidationError", {
                  attrs: { context: "Email", errors: _vm.validationErrors },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.statusInitial,
                    expression: "statusInitial",
                  },
                ],
                staticClass: "btn btn-lg btn-primary btn-block",
                on: { click: _vm.handleRequestSsoUrlCommandV1 },
              },
              [_vm._v("Sign-in")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.statusInvoking,
                    expression: "statusInvoking",
                  },
                ],
                staticClass: "btn btn-lg btn-primary btn-block",
                attrs: { disabled: "" },
              },
              [_vm._v("Signing-in...")]
            ),
            _vm._v(" "),
            _c("br"),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.statusSucceed,
                expression: "statusSucceed",
              },
            ],
          },
          [
            _c("p", [
              _vm._v(
                "\n                To complete sign-in please check your mailbox. We have sent you link to sign-in to TransparentChoice via your organizational account.\n                If you didn't receive anything please ensure that your account is valid and your organization has enabled SSO or just try again.\n                "
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-link float-right",
                  on: { click: _vm.handleTryAgain },
                },
                [_vm._v("Try again")]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("hr"),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-secondary btn-lg btn-block",
            attrs: { href: "/#/organizations/users/signin" },
          },
          [_vm._v("Sign-in with password")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }